import { UTM_LS_KEY } from 'config';

export const getUrlUtms = (search: string): Record<string, string> => {
  const urlParams = new URLSearchParams(search);
  return [...urlParams.keys()].reduce((final, key) => {
    if (!key.includes('utm_')) return final;
    return {
      ...final,
      [key]: urlParams.get(key),
    };
  }, {});
};

export const getLocalStorageUtms = (): Record<string, string> => {
  const storedString = localStorage.getItem(UTM_LS_KEY);
  if (!storedString) return {};
  try {
    const storedUtms = JSON.parse(storedString);
    return storedUtms;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Error decoding UTMS');
    return {};
  }
};

export const setLocalStorageUtms = (utms: Record<string, string>) => {
  localStorage.setItem(UTM_LS_KEY, JSON.stringify(utms));
};

export const removeLocalStorageUtms = () => {
  localStorage.removeItem(UTM_LS_KEY);
};

export const combineUtms = (
  urlUtms: Record<string, string>,
  lsUtms: Record<string, string>,
) => {
  const combined = {
    ...lsUtms,
    ...urlUtms,
  };
  setLocalStorageUtms(combined);
  return combined;
};
